/* Bundle grid carousel: reuses the theme's FoxTheme.Carousel (Swiper) so it matches the
   product carousels. FoxTheme is guaranteed present because vendor.js/theme.js load before
   this deferred script, same as the theme's own section sliders. */
if (!customElements.get('bundle-carousel')) {
  customElements.define(
    'bundle-carousel',
    class BundleCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enableSlider !== 'true') return;
        this.slides = this.querySelector('.bundle-carousel__slides');
        if (!this.slides || typeof this.sliderInstance === 'object') return;

        this.scope = this.closest('.bundle-carousel-wrap') || this;

        const mobile = parseFloat(this.dataset.mobileItems) || 1.1;
        const tablet = parseFloat(this.dataset.tabletItems) || 2;
        const desktop = parseInt(this.dataset.items, 10) || 3;
        // --swipe-gap is authored in px in the section style block; Swiper wants a number.
        const gap = parseFloat(getComputedStyle(this.slides).getPropertyValue('--swipe-gap'));
        const spaceBetween = isNaN(gap) ? 16 : gap;

        this.options = {
          slidesPerView: mobile,
          spaceBetween: spaceBetween,
          threshold: 2,
          watchSlidesProgress: true,
          loop: false,
          breakpoints: {
            768: { slidesPerView: tablet },
            1024: { slidesPerView: desktop },
          },
          navigation: {
            nextEl: this.scope.querySelector('.swiper-button-next'),
            prevEl: this.scope.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.scope.querySelector('.swiper-pagination'),
            type: 'progressbar',
          },
          mousewheel: { enabled: true, forceToAxis: true },
        };

        this.classList.add('swiper');
        this.slides.classList.add('swiper-wrapper');
        this.sliderInstance = new window.FoxTheme.Carousel(this, this.options, [window.FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();

        this.calcNavButtonsPosition();
      }

      calcNavButtonsPosition() {
        if (this.dataset.navigationPosition !== 'center_image') return;
        const firstMedia = this.querySelector('.bundle-card__media');
        const controls = this.scope.querySelector('.swiper-controls');
        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight, 10) / 2 + 'px');
        }
      }

      disconnectedCallback() {
        if (this.sliderInstance && this.sliderInstance.slider) {
          try {
            this.sliderInstance.slider.destroy();
          } catch (e) {
            /* already torn down */
          }
        }
        this.sliderInstance = false;
      }
    }
  );
}
